import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { logout } from '../../utils/util-func';

/**
 * 응답 인터셉터- 성공응답
 * @param res 응답 데이터
 * @returns 응답 데이터
 */
export const onResponse = (res: AxiosResponse) => {
  return res;
};

let isAlertShown = false;

// Request Level 에러 메시지 (null = 알럿 없이 조용히 처리)
const NETWORK_ERROR_MESSAGES: Partial<Record<string, string | null>> = {
  [AxiosError.ECONNABORTED]:
    '요청 시간이 초과되었습니다.\n잠시 후 다시 시도해 주세요.',
  [AxiosError.ERR_NETWORK]: '네트워크 연결을 확인해 주세요.',
  [AxiosError.ERR_CANCELED]: null,
};
const DEFAULT_NETWORK_ERROR =
  '일시적인 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.';

let isNetworkErrorFeedbackShown = false;
const showNetworkErrorFeedback = (code?: string | null) => {
  const message =
    code !== undefined ? NETWORK_ERROR_MESSAGES[code!] : undefined;
  if (message === null) return; // ERR_CANCELED 등 — 조용히 처리

  if (isNetworkErrorFeedbackShown) return;
  isNetworkErrorFeedbackShown = true;
  setTimeout(() => {
    isNetworkErrorFeedbackShown = false;
  }, 3000);

  const { store } = require('../../../store');
  const { openAlert } = require('../../../store/features/modalSlice');
  store.dispatch(openAlert({ message: message ?? DEFAULT_NETWORK_ERROR }));
};

export const onResError = (error: AxiosError | Error) => {
  if (axios.isAxiosError(error)) {
    const config = error.config as any;
    const { method, url } = config as InternalAxiosRequestConfig;

    // retry 체인에서 이미 처리된 에러는 중복 처리하지 않음
    // (instance(config) 재시도 시 onResError가 여러 번 호출되는 것 방지)
    if (config?.__errorHandled) return Promise.reject(error);
    config.__errorHandled = true;

    // Request Level 에러 (서버 미도달 — 네트워크 끊김, timeout, CORS 등)
    if (!error.response) {
      showNetworkErrorFeedback(error.code);
      (error as any).__handled = true;
      return Promise.reject(error);
    }

    const { statusCode, message } = error.response.data;

    // 500번대 서버 에러
    if (statusCode >= 500) {
      showNetworkErrorFeedback();
      (error as any).__handled = true;
      return Promise.reject(error);
    }

    const expectedUrl = [
      '/v1/auth/sign-in',
      '/v1/sms/with-name',
      '/v1/auth/user-authorization?check=true',
    ];

    // 반복 실패시 한번만 처리를 위한 코드
    if (isAlertShown) return;
    isAlertShown = true;
    setTimeout(() => {
      isAlertShown = false;
    }, 1000);

    if (expectedUrl.includes(url)) return Promise.reject(error);

    switch (statusCode) {
      case 401:
        alert('로그인이 필요합니다.');
        logout();
        if (!localStorage.getItem('redirect')) {
          if (window.location.href.split('/').pop() !== 'signin')
            localStorage.setItem('redirect', window.location.href);
        }
        window.location.href = '/signin';
        return error.response;

      case 403:
        alert('접근 권한이 없습니다.');
        window.location.href = '/';
        return error.response;

      default:
        return Promise.reject(error);
    }
  } else {
    console.log(`🚨 [API] | Error ${error.message}`);
  }

  return Promise.reject(error);
};
